export default __webpack_public_path__ + "static/media/spacesServices.2f77911d.svg";